import React from 'react'
import Draggable from 'react-draggable'
import styled, { css } from 'styled-components'

const START_Y = -window.innerHeight / 2 - 300 / 2
const START_X = window.innerWidth / 2 - 340 / 2

const defaultPosition = {
  x: START_X,
  y: START_Y
}

export const DraggableWindow = ({
  children,
  handle = '.draggable-handle',
  containerProps = {},
  ...rest
}) => {
  return (
    <Draggable
      positionOffset={defaultPosition}
      handle={handle}
      {...rest}
      tabIndex={-1}
    >
      <Root
        style={{ position: 'relative', zIndex: 10000 }}
        {...containerProps}
        handle={handle}
        tabIndex={-1}
      >
        {children}
      </Root>
    </Draggable>
  )
}

const Root = styled.div`
  &.react-draggable {
    ${({ handle }) => css`
      ${handle} {
        cursor: grab;
      }
    `}
  }

  &.react-draggable.react-draggable-dragging {
    ${({ handle }) => css`
      ${handle} {
        cursor: grabbing;
      }
    `}
  }
`
